
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/list",
      function () {
        return require("private-next-pages/search/list/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/list"])
      });
    }
  